// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offline-toast {
  position: fixed;
  bottom: 10vh;
  text-align: center;
  width: calc(100% - 20px);
  border-radius: 10px;
  background-color: #f32206;
  margin: 0 10px 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/ui-components/offline-toast/offline-toast.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;AACF","sourcesContent":[".offline-toast {\n  position: fixed;\n  bottom: 10vh;\n  text-align: center;\n  width: calc(100% - 20px);\n  border-radius: 10px;\n  background-color: #f32206;\n  margin: 0 10px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
